import {
  GETPATIENTDATASUCCESS,
  GETPATIENTDATAFAILED,
  REMOVEPATIENTDATA,
  GETPATIENTDATAREQ,
} from "../actions/AuthActions";

const initialState = {
  patientData: null,
  loading: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETPATIENTDATAREQ:
      return {
        ...state,
        loading: true,
      };
    case GETPATIENTDATASUCCESS:
      return {
        ...state,
        patientData: action.payload,
        loading: false,
      };
    case GETPATIENTDATAFAILED:
    case REMOVEPATIENTDATA:
      return {
        ...state,
        patientData: null,
        loading: false,
      };

    default:
      return state;
  }
};
